import { render, staticRenderFns } from "./FishingPage.vue?vue&type=template&id=5575ec0a&scoped=true&"
import script from "./FishingPage.vue?vue&type=script&lang=js&"
export * from "./FishingPage.vue?vue&type=script&lang=js&"
import style0 from "./FishingPage.vue?vue&type=style&index=0&id=5575ec0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5575ec0a",
  null
  
)

export default component.exports